const closeButtonLabel = "Close";
const enMT = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  enMT as default
};
